import CallScoreLoader from "../CallScoreLoader/CallScoreLoader";
import React from "react";
import "./generateCallScore.scss"

const GenerateCallScore = () => {
    return <div className={"generate-call-score-container"}>
        <p className={"steps-title"}>Generating call score...</p>
        <div className={"loader"}>
            <CallScoreLoader />
        </div>
    </div>
}

export default GenerateCallScore